const Icon = (props: any) => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3367_28519)">
      <path
        d="M10.7529 8.84961C10.2697 8.84961 9.87793 9.24136 9.87793 9.72461V14.3338C9.35485 14.6363 9.00293 15.2018 9.00293 15.8496C9.00293 16.8161 9.7864 17.5996 10.7529 17.5996C11.7195 17.5996 12.5029 16.8161 12.5029 15.8496C12.5029 15.2018 12.151 14.6363 11.6279 14.3338V9.72461C11.6279 9.24136 11.2362 8.84961 10.7529 8.84961Z"
        fill="white"
      />
      <path
        d="M9.87793 6.22454C9.87793 5.7413 10.2697 5.34954 10.7529 5.34954C11.2362 5.34954 11.6279 5.7413 11.6279 6.22454C11.6279 6.70779 11.2362 7.09954 10.7529 7.09954C10.2697 7.09954 9.87793 6.70779 9.87793 6.22454Z"
        fill="white"
      />
      <path
        d="M14.2529 7.09968C13.7697 7.09968 13.3779 7.49143 13.3779 7.97468C13.3779 8.45793 13.7697 8.84968 14.2529 8.84968C14.7362 8.84968 15.1279 8.45793 15.1279 7.97468C15.1279 7.49143 14.7362 7.09968 14.2529 7.09968Z"
        fill="white"
      />
      <path
        d="M5.50293 12.3495C5.01968 12.3495 4.62793 11.9578 4.62793 11.4745C4.62793 10.9913 5.01968 10.5995 5.50293 10.5995C5.98617 10.5995 6.37793 10.9913 6.37793 11.4745C6.37793 11.9578 5.98617 12.3495 5.50293 12.3495Z"
        fill="white"
      />
      <path
        d="M6.37793 7.97468C6.37793 8.45793 6.76968 8.84968 7.25293 8.84968C7.73617 8.84968 8.12793 8.45792 8.12793 7.97468C8.12793 7.49143 7.73617 7.09968 7.25293 7.09968C6.76968 7.09968 6.37793 7.49143 6.37793 7.97468Z"
        fill="white"
      />
      <path
        d="M16.0029 12.3495C15.5197 12.3495 15.1279 11.9578 15.1279 11.4745C15.1279 10.9913 15.5197 10.5995 16.0029 10.5995C16.4862 10.5995 16.8779 10.9913 16.8779 11.4745C16.8779 11.9578 16.4862 12.3495 16.0029 12.3495Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7529 21.0997C16.0686 21.0997 20.3779 16.7904 20.3779 11.4747C20.3779 6.15894 16.0686 1.84968 10.7529 1.84968C5.43719 1.84968 1.12793 6.15894 1.12793 11.4747C1.12793 16.7904 5.43719 21.0997 10.7529 21.0997ZM10.7529 19.3437C6.40699 19.3437 2.88391 15.8206 2.88391 11.4747C2.88391 7.12874 6.40699 3.60565 10.7529 3.60565C15.0989 3.60565 18.622 7.12874 18.622 11.4747C18.622 15.8206 15.0989 19.3437 10.7529 19.3437Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3367_28519">
        <rect width="21" height="21" fill="white" transform="translate(0.25293 0.974609)" />
      </clipPath>
    </defs>
  </svg>
);

export default Icon;
